import React, { ComponentProps, memo } from 'react'

import { ScreenLoader } from './ScreenLoader'
import { useTranslation } from './services'

/** @deprecated we prefer to use <LogoScreenLoader /> if module is already migrated to it - stay consistent with used loader in module for now */
export const DefaultScreenLoader = memo(
  ({ ...rest }: ComponentProps<typeof ScreenLoader>) => {
    const { t } = useTranslation()
    return <ScreenLoader {...rest}>{t('defaultLoadingMessage')}</ScreenLoader>
  },
)
